import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import Badge from 'material-ui/Badge';
import { Tabs, Tab } from 'material-ui/Tabs';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import Chip from 'material-ui/Chip';
import Moment from 'react-moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import Loading from '../components/Loading';
import PaginationFooter from '../components/PaginationFooter';
import API from '../api/ApiTool';

const styles = {
  chip: {
    margin: 4,
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  }
};

const OrphansTable = (props) => {
  if (props.loading) {
    return <Loading />
  }
  return (
    <div>
      <Table style={{backgroundColor: "#0f172a"}}>
        <TableHead>
          <TableRow>
            <TableCell>
              <a style={{cursor: 'pointer', color: '#3b82f6'}} onClick={() => props.alertHandleOpen()}>
                Release selected
              </a>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'number'}
                direction={props.getDirection('number')}
                onClick={() => props.handleSort('number')}
              >
                Number
              </TableSortLabel>
            </TableCell>
            <TableCell>Billing Provider</TableCell>
            <TableCell>Company</TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'added_on'}
                direction={props.getDirection('added_on')}
                onClick={() => props.handleSort('added_on')}
              >
                Added On
              </TableSortLabel>
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.numbers.map((number, i) => {
            const isSelected = props.isSelected(number[0]);
            return (
              <TableRow
                key={i}
                role="checkbox"
                aria-checked={isSelected}
                selected={isSelected}
                onClick={event => props.handleClick(number[0])}
              >
                <TableCell padding="checkbox">
                  <Checkbox checked={isSelected} />
                </TableCell>
                <TableCell>{number[0]}</TableCell>
                <TableCell>{props.provider}</TableCell>
                <TableCell>{'-'}</TableCell>
                <TableCell>
                  {number[1]
                    ?
                    <Moment format="YYYY/MM/DD">
                      {number[1]}
                    </Moment>
                    :
                      undefined
                  }
                </TableCell>
                <TableCell>
                  <div style={styles.wrapper}>
                    <Chip labelStyle={{fontSize: '10px'}} style={{marginTop: '2px'}}
                      labelColor='#06b6d4'>
                      {'Orphan'}
                    </Chip>
                  </div>
                </TableCell>
                <TableCell>
                  <RaisedButton label="Release"
                    onClick={() => props.release(null, number[0])} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

const NumbersTable = (props) => {
  if (props.loading) {
    return <Loading />
  }
  return (
    <div>
      <Table>
        <TableHead style={{backgroundColor: "#1e293b"}}>
          <TableRow>
            <TableCell>
              <a style={{cursor: 'pointer', color: '#3b82f6'}} onClick={() => props.alertHandleOpen()}>
                Release selected
              </a>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'number'}
                direction={props.getDirection('number')}
                onClick={() => props.handleSort('number')}
              >
                Number
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'billing_provider'}
                direction={props.getDirection('billing_provider')}
                onClick={() => props.handleSort('billing_provider')}
              >
                Billing Provider
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'route_to__company__name'}
                direction={props.getDirection('route_to__company__name')}
                onClick={() => props.handleSort('route_to__company__name')}
              >
                Company
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'created'}
                direction={props.getDirection('created')}
                onClick={() => props.handleSort('created')}
              >
                Created
              </TableSortLabel>
            </TableCell>
            <TableCell>Last Call</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{backgroundColor: "#0f172a"}}>
          {props.data.numbers.map((number, i) => {
            const isSelected = props.isSelected(number.id);
            return (
              <TableRow
                key={i}
                role="checkbox"
                aria-checked={isSelected}
                selected={isSelected}
                onClick={event => props.handleClick(number.id)}
              >
                <TableCell padding="checkbox">
                  <Checkbox checked={isSelected} />
                </TableCell>
                <TableCell>{number.number}</TableCell>
                <TableCell>{number.billing_provider}</TableCell>
                <TableCell>{
                    number.route_to.company
                    ? <a style={{cursor: 'pointer', color: '#3b82f6'}}
                        onClick={() => {props.push(`/company-detail/${number.route_to.company.id}`)}}>
                        {number.route_to.company.name}
                      </a>
                    : '-'
                  }</TableCell>
                <TableCell>
                  <Moment format="YYYY/MM/DD">
                    {number.created}
                  </Moment>
                </TableCell>
                <TableCell>
                  {number.last_call
                    ? <Moment format="YYYY/MM/DD">{number.last_call}</Moment>
                    : '—'
                  }
                </TableCell>
                <TableCell>
                  <div style={styles.wrapper}>
                    {number.route_to.company.status==='not-subscribed' || number.route_to.company.tariff===null
                      ?
                        <Chip labelStyle={{fontSize: '10px'}} style={{marginTop: '2px'}}
                          labelColor='#06b6d4'>
                          {'No subscribed'}
                        </Chip>
                      :
                        undefined
                    }
                    {number.deleted
                      ?
                        <Chip labelStyle={{fontSize: '10px'}} style={{marginTop: '2px'}}
                          labelColor='#06b6d4'>
                          {'DID deleted'}
                        </Chip>
                      :
                        undefined
                    }
                    {number.route_to.deleted
                      ?
                        <Chip labelStyle={{fontSize: '10px'}} style={{marginTop: '2px'}}
                          labelColor='#06b6d4'>
                          {'Bridge deleted'}
                        </Chip>
                      :
                        undefined
                    }
                  </div>
                </TableCell>
                <TableCell>
                  <RaisedButton
                    labelStyle={{fontSize: "10px"}}
                    label={
                      number.route_to.company.status==='not-subscribed' ||
                      number.route_to.company.tariff===null
                      ? 'Clean Up' : 'Release'}
                    onClick={() => props.release(number.id, number.number)} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <div>
        {props.loadingMore
          ?
            <p style={{color: '#94a3b8', fontFamily: '"Inter", system-ui, sans-serif', marginLeft: '15px'}}>
              Loading more...
            </p>
          :
            undefined
        }
      </div>
    </div>
  );
}

class NumbersCleanup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numbers: {},
      orphans: {},
      multiSelect: [],
      selectedProvider: undefined,
      alertOpen: false,
      notificationOpen: false,
      notificationText: '',
      limit: 25,
      loading: false,
      property: 'created',
      order: 'asc',
      loadingMore: false
    };

    window.onscroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop
        === document.documentElement.offsetHeight
      ) {
        if (Object.keys(this.state.numbers).length !== 0 && this.state.selectedProvider === undefined && !this.state.loadingMore) {
          this.fetchData(this.state.numbers.offset, this.state.limit, true, false);
        }
      }
    };
  }

  fetchData(offset, limit, pullDBNumbers, pullOrphanNumbers) {    
    let property = this.state.property;
    const direction = this.state.order;

    if (direction === 'asc') {
      property = '-' + property;
    }

    if (offset > 0) {
      this.setState({ loadingMore: true });
    }
    else {
      this.setState({ loading: true });
    }

    if (pullDBNumbers) {
      API.GET(`/bridges/numbers-cleanup/?offset=${offset}&limit=${limit}&order_by=${property}`)
        .then(response => response.json())
        .then(data => {
          if (offset === 0) {
            this.setState({ numbers: data, multiSelect: [] });
          }
          else {
            let numbers = this.state.numbers;
            numbers.numbers = numbers.numbers.concat(data.numbers);
            numbers.offset = data.offset;
            this.setState({ numbers: numbers });
          }
        })
        .then(() => this.setState({ loading: false }))
        .then(() => this.setState({ loadingMore: false }))
        .then(() => this.setState({ notificationOpen: false }))
    }

    if (pullOrphanNumbers) {
      API.GET(`/bridges/orphans-numbers-cleanup/?&order_by=${property}`)
        .then(response => response.json())
        .then(data => this.setState({ orphans: data, multiSelect: [] }))
        .then(() => this.setState({ loading: false }))
        .then(() => this.setState({ notificationOpen: false }))
    }
  }

  componentDidMount() {
    this.fetchData(0, this.state.limit, true, true);
  }

  release = (id, number, selectedRows) => {
    let url = null;
    let body = null;

    this.setState({ alertOpen: false });
    this.setState({ loading: true });

    if (id) {
      url = `/bridges/numbers-cleanup/`;
      body = { 'ids': [id] };
    }
    else if (number) {
      url = `/bridges/orphans-numbers-cleanup/`;
      body = {
        'numbers': [number],
        'provider': this.state.selectedProvider
       };
    }
    else if (selectedRows && !this.state.selectedProvider){
      url = `/bridges/numbers-cleanup/`;
      body = { 'ids': selectedRows };
    }
    else {
      url = `/bridges/orphans-numbers-cleanup/`;
      body = {
        'numbers': selectedRows,
        'provider': this.state.selectedProvider
       };
    }

    API.POST(url, body)
      .then(response => response.json())
      .then(data => {
        if (data.status === 200) {
          this.setState({ notificationOpen: true });
          this.setState({ notificationText: 'Number deleted successfully' });
          if (id || (selectedRows && !this.state.selectedProvider)) {
            this.fetchData(0, this.state.limit, true, false);
          }
          else {
            this.fetchData(0, this.state.limit, false, true);
          }
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        this.setState({ notificationOpen: true });
        this.setState({
          notificationText: 'The server encountered an error. Please try again later'
        });
      });

  };

  alertHandleClose = () => {
    this.setState({ alertOpen: false});
  };

  alertHandleOpen = () => {
    this.setState({ alertOpen: true });
  };

  handleSubmit = () => {
    this.release(undefined, undefined, this.state.multiSelect);
  }

  handleClick(idOrNumber) {
    const index = this.state.multiSelect.indexOf(idOrNumber);
    if(index === -1) {
      const newMultiSelected = this.state.multiSelect;
      newMultiSelected.push(idOrNumber);
      this.setState({ multiSelect: newMultiSelected });
    }
    else {
      const newMultiSelected = this.state.multiSelect;
      delete newMultiSelected[index];
      this.setState({ multiSelect: newMultiSelected });
    }
  };

  isSelected = idOrNumber => this.state.multiSelect.indexOf(idOrNumber) !== -1;

  changeTab = (provider) => {
    this.setState({ multiSelect: [] });
    this.setState({ selectedProvider: provider });

    this.setState({ property: 'created' }, () => {
      this.setState({ order: 'asc' }, () => {
        if (!this.state.selectedProvider) {
          this.fetchData(0, this.state.limit, true, false);
        }
        else {
          this.fetchData(0, this.state.limit, false, true);
        }
      });
    });
  }

  handleSort(property) {
    if (property === this.state.property && this.state.order === 'asc') {
      this.setState({ order: 'desc' }, () => {
        if (!this.state.selectedProvider) {
          this.fetchData(0, this.state.limit, true, false);
        }
        else {
          this.fetchData(0, this.state.limit, false, true);
        }
      });
    }
    else if (property === this.state.property && this.state.order === 'desc') {
      this.setState({ order: 'asc' }, () => {
        if (!this.state.selectedProvider) {
          this.fetchData(0, this.state.limit, true, false);
        }
        else {
          this.fetchData(0, this.state.limit, false, true);
        }
      });
    }
    else {
      this.setState({ property: property }, () => {
        this.setState({ order: 'asc' }, () => {
          if (!this.state.selectedProvider) {
            this.fetchData(0, this.state.limit, true, false);
          }
          else {
            this.fetchData(0, this.state.limit, false, true);
          }
        });
      });
    }
  }

  getDirection(property) {
    let order = 'asc';
    if (property === this.state.property && this.state.order === 'asc') {
      order = 'asc';
    }
    else if (property === this.state.property && this.state.order === 'desc') {
      order = 'desc';
    }
    return order;
  }

  render() {
    const { numbers, alertOpen, notificationOpen, notificationText,
      orphans, loading } = this.state;

    console.log("numbers:", numbers)
    console.log("orphans:", orphans)

    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.alertHandleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSubmit}
      />,
    ];
    if (Object.keys(numbers).length === 0 || Object.keys(orphans).length === 0) {
      return (
        <Loading />
      );
    }
    return (
      <div>
        <Snackbar
          open={notificationOpen}
          message={notificationText}
          autoHideDuration={4000}
        />
        <Dialog
          title="Release number"
          actions={actions}
          modal={false}
          open={alertOpen}
          onRequestClose={this.alertHandleClose}
        >
          Are you sure want to release the selected numbers?
        </Dialog>
        <Tabs>
          <Tab
            label={
              <Badge
                onClick={() => this.changeTab(undefined)}
                badgeContent={numbers.total}
                secondary={true}
                badgeStyle={{top:4}}
              >
                Numbers
              </Badge>
            }>
            <NumbersTable
              data={numbers}
              release={this.release}
              push={this.props.history.push}
              loading={loading}
              handleClick={this.handleClick.bind(this)}
              isSelected={this.isSelected.bind(this)}
              alertHandleOpen={this.alertHandleOpen.bind(this)}
              handleSort={this.handleSort.bind(this)}
              getDirection={this.getDirection.bind(this)}
              property={this.state.property}
              loadingMore={this.state.loadingMore}
            />
          </Tab>
          <Tab
            label={
              <Badge
                onClick={() => this.changeTab('bandwidth')}
                badgeContent={orphans.orphans_bandwidth.length}
                secondary={true}
                badgeStyle={{top:4}}
              >
                Bandwidth orphans
              </Badge>
            }>
            <div>
              <OrphansTable
                numbers={orphans.orphans_bandwidth}
                provider={'bandwidth'}
                loading={loading}
                release={this.release}
                handleClick={this.handleClick.bind(this)}
                isSelected={this.isSelected.bind(this)}
                alertHandleOpen={this.alertHandleOpen.bind(this)}
                handleSort={this.handleSort.bind(this)}
                getDirection={this.getDirection.bind(this)}
                property={this.state.property}
              />
            </div>
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default withRouter(NumbersCleanup);



// WEBPACK FOOTER //
// ./src/pages/NumbersCleanup.js